module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5n4r8r7n-f50d6ac8c0c6473e08592f2840656a26.svg";